export default __webpack_public_path__ + "static/media/330_business04-jp-web.e431e913.png";